import React, { useState } from 'react';

const getRandomTools = (tools, count) => {
  const shuffled = tools.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

const Accordion = ({ title, isOpenByDefault, children }) => {
  const [isOpen, setIsOpen] = useState(isOpenByDefault);

  return (
    <div className="mb-4 bg-gray-100 p-4 rounded-lg">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full text-left text-lg font-semibold text-gray-800 py-2"
      >
        {title}
        <span className="float-right">{isOpen ? '-' : '+'}</span>
      </button>
      {isOpen && <div className="mt-2">{children}</div>}
    </div>
  );
};

const ResultPhase = ({ selectedItems = [], onRestart, t }) => {
  const qualitativeCount = selectedItems.filter(item =>
    item.includes('¿Necesitas saber') ||
    item.includes('¿Quieres descubrir') ||
    item.includes('¿Necesitas retroalimentación') ||
    item.includes('¿Quieres explorar') ||
    item.includes('¿Necesitas escuchar')
  ).length;

  const quantitativeCount = selectedItems.filter(item =>
    item.includes('¿Necesitas calcular') ||
    item.includes('¿Quieres probar') ||
    item.includes('¿Necesitas medir') ||
    item.includes('¿Quieres comparar') ||
    item.includes('¿Necesitas medir cuán')
  ).length;

  const getResearchType = () => {
    if (qualitativeCount > quantitativeCount) return 'qualitative';
    if (quantitativeCount > qualitativeCount) return 'quantitative';
    return 'mixed';
  };

  const researchType = getResearchType();
  const currentRecommendations = t.descriptions[researchType];
  const tests = t.tests[researchType];
  const randomTools = getRandomTools(t.toolsList[researchType], 4);

  return (
    <div className="w-full max-w-lg bg-white shadow-lg rounded-lg p-8">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">{t.title}</h2>
      <p className="text-gray-700 text-lg mb-4">{t.recommendation}</p>
      <p className="text-xl font-semibold text-indigo-600 mb-6">{currentRecommendations}</p>

      <Accordion title={t.testsTitle} isOpenByDefault={true}>
        <ul className="space-y-4">
          {tests.map((test, index) => (
            <li key={index} className="flex items-start space-x-4">
              <span className="text-indigo-500 mt-1">✔️</span>
              <div>
                <strong className="text-gray-900">{test.name}:</strong>
                <p className="text-gray-600">{test.detail}</p>
              </div>
            </li>
          ))}
        </ul>
      </Accordion>

      <Accordion title={t.tools} isOpenByDefault={false}>
        <div className="grid grid-cols-2 gap-4">
          {randomTools.map((tool, index) => (
            <div key={index} className="flex items-start space-x-2">
              <span className="text-indigo-500 mt-1">🔧</span>
              <span className="text-gray-900">{tool}</span>
            </div>
          ))}
        </div>
        <p className="text-sm text-gray-500 mt-4">
          {t.note}
        </p>
      </Accordion>

      <div className="mt-8 text-center">
        <p className="text-lg text-gray-800 mb-4">{t.share}</p>
        <div className="flex justify-center space-x-4">
          <a href="https://www.facebook.com/sharer/sharer.php?u=https://ux-balance.vercel.app/" target="_blank" rel="noopener noreferrer">
            facebook
          </a>
          <a href="https://twitter.com/intent/tweet?url=https://ux-balance.vercel.app/" target="_blank" rel="noopener noreferrer">
            X
          </a>
          <a href="https://www.linkedin.com/shareArticle?mini=true&url=https://ux-balance.vercel.app/" target="_blank" rel="noopener noreferrer">
            linkedin
          </a>
          <a href="https://wa.me/?text=https://ux-balance.vercel.app/" target="_blank" rel="noopener noreferrer">
            whastapp
          </a>
        </div>
        <button
          onClick={onRestart}
          className="mt-8 w-full font-bold bg-red-600 text-white py-3 rounded-lg hover:bg-red-500 font-semibold"
        >
          {t.restart}
        </button>
      </div>
    </div>
  );
};

export default ResultPhase;
